<template>
  <div>
    <a-menu
      mode="inline"
      theme="dark"
      :open-keys="openKeys"
      v-model="selectedKeys"
      :inline-collapsed="collapsed"
      @select="handleSelect"
      @openChange="onOpenChange"
    >
      <template v-for="(item, index) in menudata">
        <a-menu-item
          :key="item.path"
          :title="item.title"
          v-if="!item.child"
          style="display: flex;align-items: center;padding-left: 10px"
          @mouseover="handlemouseover(index)"
          @mouseleave="handlemouseleave(index)"
        >
          <component
            :is="item.Icon['components']"
            :theme="item.Icon['theme']"
            :size="item.Icon['size']"
            :fill="item.Icon['fill']"
            :strokeWidth="item.Icon['strokeWidth']"
            style="margin-right: 5px;"
          ></component>
          <!--          <a-icon type="mail" />-->
          <span v-show="!IsCollapsed">{{ item.title }}</span>
        </a-menu-item>
        <a-sub-menu :key="item.path" v-else style="background: #0A5BA8;">
        <span
          slot="title"
          @mouseover="handlemouseover(index)"
          @mouseleave="handlemouseleave(index)"
          style="display: flex;align-items: center;margin-left: -13px"
        ><component
          :is="item.Icon['components']"
          :theme="item.Icon['theme']"
          :size="item.Icon['size']"
          :fill="item.Icon['fill']"
          :strokeWidth="item.Icon['strokeWidth']"
          style="margin-right: 5px"
        ></component
        ><span v-show="!IsCollapsed">{{ item.title }}</span></span
        >
          <template v-for="iten in item.child">
            <a-menu-item
              :key="!iten.child ? iten.code : iten.code"
              :parentMenu="iten.parentMenu"
              style="padding-left: 30px;"
              v-if="!iten.child"
            >{{ iten.title }}</a-menu-item
            >

            <a-sub-menu :key="iten.path" v-else style="margin-top: -5px">
            <span slot="title" style="margin-left: -17px">{{
                iten.title
              }}</span>
              <template v-for="iten2 in iten.child">
                <a-menu-item
                  :key="iten2.code"
                  :parentMenu="iten2.parentMenu"
                  style="padding-left: 40px"
                >{{ iten2.title }}</a-menu-item
                >
              </template>
            </a-sub-menu>
          </template>
        </a-sub-menu>
      </template>
    </a-menu>

    <AlertMessage :visible="visible" @handleOk="handleOk" @handleClose="handleClose"></AlertMessage>
  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import AlertMessage from "@/components/AlertMessage.vue";
import { checkTime } from "@/plugins/validsUtils";
export default {
  name: "UserMenu",
  data() {
    return {
      visible:false,
      collapsed: true,
      includeRouter: [],
      selectedKeys: [],
      menudata: [],
      openKeys: []
    };
  },
  props: {
    IsCollapsed: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    activeKey(n, o) {
      if (n.indexOf("/") != -1) {
        const openKeys = n.split("/");
        const openKeysLength = openKeys.length;
        this.IsSelectActiveIcon(openKeys[1], openKeysLength);
        if (openKeys.length == 3) {
          // [`/${openKeys[1]}`]

          this.openKeys = [`/${openKeys[1]}`];
        } else if (openKeys.length == 4) {
          this.openKeys = [
            `/${openKeys[1]}`,
            `/${openKeys.slice(1, openKeys.length - 1).join("/")}`
          ];
        }
      }
      this.selectedKeys = [n];
    },
    "$route.path": {
      handler() {
        this.selectKey = this.$route.path.split();
        this.getTableSeleted([]);
      },
      immediate: true
    },

    routers: {
      handler(n, o) {
        const that = this;
        that.MenuPermissList(n);
        // const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));
        // if(userInfo){
        //   if(userInfo.user.superuser==1){
        //     this.menudata=this.sidebarRouters
        //   }
        //   else{
        //     this.menudata=this.GenerateRoutes(n);
        //   }
        // }

        // this.total = size;
      },
      deep: true
    }
  },
  computed: {
    ...mapState([
      "sidebarRouters",
      "supernormalRouters",
      "StaticSidebarRouters",
      "routers",
      "activeKey"
    ])
  },
  components:{
    AlertMessage,
  },

  mounted() {
    this.MenuPermissList();
    // const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));
    //
    // if(userInfo){
    //   if(userInfo.user.superuser==1){
    //     this.menudata= this.sidebarRouters
    //   }
    //   else{
    //
    //     this.menudata=this.GenerateRoutes(this.routers);
    //
    //   }
    // }
    let n = this.activeKey;
    const openKeys = n.split("/");
    if (n.indexOf("/") != -1) {
      if (openKeys.length >= 3) {
        if (openKeys.length == 3) {
          // [`/${openKeys[1]}`]

          this.openKeys = [`/${openKeys[1]}`];
        } else if (openKeys.length == 4) {
          this.openKeys = [
            `/${openKeys[1]}`,
            `/${openKeys.slice(1, openKeys.length - 1).join("/")}`
          ];
        }
        // this.openKeys=[`/${openKeys[1]}`]
      }
    }
    this.selectedKeys = [n];
  },

  methods: {
    ...mapMutations({
      isactivekey: "IS_ACTIVE_KEY"
    }),
    ...mapActions(["getTableSeleted", "setRouterTags", "setMenuState"]),

    MenuPermissList(data = this.routers) {
      console.log(data);
      const userInfo = JSON.parse(sessionStorage.getItem("unInfo"));
      const StaticSidebarRouters = this.StaticSidebarRouters;
      const sidebarRouters = this.sidebarRouters;
      if (userInfo) {
        if (userInfo.user.superuser == 1 && userInfo.user.id == '966500') {
         const supernormalRouters = this.supernormalRouters;
         for(let i = 0; i < sidebarRouters.length; i++){
           if(sidebarRouters[i].code2 == 'normal'){
             sidebarRouters[i] = supernormalRouters;
           }
         }
          this.menudata = [...StaticSidebarRouters, ...sidebarRouters];
        } else {
          const PermissMenu = this.GenerateRoutes(data);
          if (userInfo.user.orgType == 1 || userInfo.user.orgType == 6) {
            this.menudata = [...PermissMenu];
          } else {
            this.menudata = [...StaticSidebarRouters, ...PermissMenu];
          }
        }
      }
    },
    IsSelectActiveIcon(parentCode, openKeysLength) {
      let fillColor = ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"];
      if (openKeysLength == 2) {
        fillColor = ["#0A5BA8", "#FFFFFF", "#0A5BA8", "#FFFFFF"];
      }
      let menudata = this.menudata.filter((item, index2) => {
        if (parentCode == item.code2) {
          item.Icon.fill = fillColor;
        } else {
          item.Icon.fill = ["rgba(255, 255, 255, 0.65)"];
        }
        return item;
      });
      this.menudata = menudata;
    },

    handlemouseover(index) {
      let menudata = [];
      let selectedKeys = this.selectedKeys[0].split("/");
      if (this.selectedKeys.length != 0) {
        if (this.menudata[index].code2 != selectedKeys[1]) {
          this.menudata[index].Icon.fill = [
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF"
          ];
        }
      } else {
        this.menudata[index].Icon.fill = [
          "#FFFFFF",
          "#FFFFFF",
          "#FFFFFF",
          "#FFFFFF"
        ];
      }
    },
    handlemouseleave(index) {
      let selectedKeys = this.selectedKeys[0].split("/");
      if (this.selectedKeys.length != 0) {
        if (this.menudata[index].code2 != selectedKeys[1]) {
          this.menudata[index].Icon.fill = ["rgba(255, 255, 255, 0.65)"];
        }
      } else {
        this.menudata[index].Icon.fill = ["rgba(255, 255, 255, 0.65)"];
      }
      // this.menudata = menudata;
    },
    onOpenChange(openKeys) {
      if (openKeys.length == 0) {
        this.openKeys = openKeys;
        return false;
      }
      const latestOpenKey = openKeys.find(
        key => this.openKeys.indexOf(key) === -1
      );
      if (latestOpenKey) {
        if(latestOpenKey == '/historyDataManage' || latestOpenKey == '/limitModel'){
          if(checkTime('2024-08-02 00:00:00','2024-08-24 23:59:59')){
            this.visible = true;
          }
        }
        let num = latestOpenKey.split("/").length - 1;
        if (num > 1) {
          this.openKeys = openKeys;
        } else {
          this.openKeys = [latestOpenKey];
        }
      } else {
        this.openKeys = openKeys;
      }
      // this.openKeys=[latestOpenKey]
    },
    handleOk(){
      this.visible = false;
    },
    handleClose(){
      this.visible = false;
    },
    hasPermission(roles, route) {
      let flag = roles.some(role => {
        if (role.meta.hasOwnProperty("show")) {
          return role.name == route && role.meta.show == 1;
        }
      });
      return flag;

      // return roles.some(role => role.name==route)
    },
    routersIndex(roles, route) {
      return roles.findIndex(role => {
        if (role.meta.hasOwnProperty("show")) {
          return role.name == route && role.meta.show == 1;
        }
      });

      // return roles.findIndex(role => role.name==route)
    },

    //处理按钮权限
    CtrlButton(data) {
      if (data && data.length !== 0) {
        let buttonPrivilege = data.filter(d => {
          return d.type === 3;
        });
        if (buttonPrivilege.length !== 0) {
          buttonPrivilege = buttonPrivilege.map(d => {
            buttonPrivilege[d.code] = d;
          });
          sessionStorage.setItem("buttonPrivilege", JSON.serialize(buttonPrivilege));
        }
      }
    },

    GenerateRoutes(data) {
      let roles = data;
      let asyncRouterMap = this.sidebarRouters;
      const accessedRouters = asyncRouterMap.filter(v => {
        if (this.hasPermission(roles, v.code2)) {
          let index = this.routersIndex(roles, v.code2);
          if (v.child && v.child.length !== 0) {
            v.child = v.child.filter(child => {
              let index2 = this.routersIndex(
                roles[index].children,
                child.code2
              );
              if (this.hasPermission(roles[index].children, child.code2)) {
                if (child.child && v.child.length !== 0) {
                  child.child = child.child.filter(child2 => {
                    let index3 = this.routersIndex(
                      roles[index].children[index2].children,
                      child2.code2
                    );
                    if (
                      this.hasPermission(
                        roles[index].children[index2].children,
                        child2.code2
                      )
                    ) {
                      return child2;
                    }
                    return false;
                  });
                }
                return child;
              }
              return false;
            });
          }

          return v;
        }
        return false;
      });
      return accessedRouters;
    },
    handleSelect({ item, key }) {


      if (key == "/website") {

        this.IsSelectActiveIcon("website", 2);
        const url = key + "/";
        window.open(url, "_blank");
        return false;
      }
      if (key == "/tqcStat") {
        // this.IsSelectActiveIcon("website", 2);
        const url = '/dp' + "/";
        window.open(url, "_blank");
        return false;
      }



      if(key.indexOf("/platformDocking")==0){
        const key2 = key.split("-");
        this.$router.push({ path: `${key2[0]}` });
        return false;
      }

      if (this.selectedKeys[0] != key) {
        const key2 = key.split("-");
        console.log(key2);
        // -${key2[1]
        this.selectedKeys = [`${key2[0]}`];
        let keyData = `/${key2[0]}`;
        this.$router.push({ path: `${key2[0]}` });
        this.setRouterTags(this.$route);
        // this.setMenuState("menu");
        this.isactivekey(key2[0]);
      }
    }

    // handleSelect({item, key}) {
    //   if (this.selectedKeys[0] !== key) {
    //     const key2=key.split("-");
    //     this.selectedKeys = [`${key2[0]}-${key2[1]}`];
    //     this.$router.push({path:`${key2[0]}`});
    //   }
    // },

    // handleSelect({key}){
    //   this.$router.push({path:key});
    // }
  }
};
</script>

<style scoped>
.ant-menu-submenu-title {
  padding-left: 10px;
}

.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  /*background: #004082;*/
  /*box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.45);*/
  background: #f1f4f6;
  color: #0a5ba8;
  font-weight: bold;
  /*background: #364250;*/
}
.ant-menu-dark .ant-menu-inline .ant-menu-sub {
  background: #004082;
  color: #fff;
}

.ant-menu-dark {
  height: 100%;
  text-align: left;
  background: #0a5ba8;

  /*color: rgba(255, 255, 255, 0.65);*/
  /*background: #4e596b;*/
  /*background: linear-gradient(135deg, #0062A6 0%, #001B5A 100%);*/
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-menu-dark::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>

<!--<template>-->
<!--  <a-menu @click="handleClick" mode="inline" theme="dark"   :inline-collapsed="collapsed"  @select="handleSelect">-->
<!--    <template v-for="item in menudata">-->
<!--      <a-menu-item :key="item.code" v-if="!item.child" align="left">-->
<!--        <a-icon type="mail" />-->
<!--        <span>{{ item.name }}</span>-->
<!--      </a-menu-item>-->
<!--      <a-sub-menu :key="item.code" v-else>-->
<!--        <span slot="title">{{item.name }}</span>-->
<!--        <template v-for="iten in item.child">-->
<!--          <a-menu-item :key="!iten.child?iten.code+'-'+iten.id:iten.code" :parentMenu="iten.parentMenu" v-if="!iten.child">{{ iten.name }}</a-menu-item>-->

<!--          <a-sub-menu :key="iten.code" v-else>-->
<!--            <span slot="title">{{ iten.name }}</span>-->
<!--            <template v-for="iten2 in iten.child">-->
<!--              <a-menu-item :key="iten2.code+'-'+iten2.id" :parentMenu="iten2.parentMenu">{{ iten2.name }}</a-menu-item>-->
<!--            </template>-->
<!--          </a-sub-menu>-->
<!--        </template>-->
<!--      </a-sub-menu>-->
<!--    </template>-->
<!--&lt;!&ndash;    <template v-for="item in menudata">&ndash;&gt;-->
<!--&lt;!&ndash;      <a-menu-item :key="item.path" v-if="!item.child">&ndash;&gt;-->
<!--&lt;!&ndash;        <a-icon type="mail" />&ndash;&gt;-->
<!--&lt;!&ndash;        <span>{{ item.title }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;      </a-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;      <a-sub-menu :key="item.path" v-else style="background: #4e596b;">&ndash;&gt;-->
<!--&lt;!&ndash;        <span slot="title">{{ item.title }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;        <template v-for="iten in item.child">&ndash;&gt;-->
<!--&lt;!&ndash;          <a-menu-item :key="!iten.child?iten.code+'-'+iten.id:iten.code" :parentMenu="iten.parentMenu" v-if="!iten.child">{{ iten.title }}</a-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;          <a-sub-menu :key="iten.code" v-else>&ndash;&gt;-->
<!--&lt;!&ndash;            <span slot="title">{{ iten.title }}</span>&ndash;&gt;-->
<!--&lt;!&ndash;            <template v-for="iten2 in iten.child">&ndash;&gt;-->
<!--&lt;!&ndash;              <a-menu-item :key="iten2.code+'-'+iten2.id" :parentMenu="iten2.parentMenu">{{iten2.title }}</a-menu-item>&ndash;&gt;-->
<!--&lt;!&ndash;            </template>&ndash;&gt;-->
<!--&lt;!&ndash;          </a-sub-menu>&ndash;&gt;-->
<!--&lt;!&ndash;        </template>&ndash;&gt;-->
<!--&lt;!&ndash;      </a-sub-menu>&ndash;&gt;-->
<!--&lt;!&ndash;    </template>&ndash;&gt;-->

<!--&lt;!&ndash;      <a-menu-item v-for="(item,index) in sidebarRouters" :key="item.path">&ndash;&gt;-->
<!--&lt;!&ndash;        <a-icon type="user" />&ndash;&gt;-->
<!--&lt;!&ndash;        <span>{{item.title}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;      </a-menu-item>&ndash;&gt;-->
<!--  </a-menu>-->
<!--</template>-->

<!--<script>-->
<!--import {mapState,mapActions} from 'vuex'-->

<!--export default {-->
<!--  name: "UserMenu",-->
<!--  data(){-->
<!--    return{-->
<!--      id:0,-->
<!--      collapsed:true,-->
<!--      includeRouter:[],-->
<!--      selectedKeys:[],-->
<!--      menudata:[]-->
<!--    }-->
<!--  },-->

<!--watch:{-->
<!--  '$route.path': {-->
<!--    handler() {-->
<!--      this.selectKey = this.$route.path.split()-->
<!--    },-->
<!--    immediate: true,-->
<!--  },-->

<!--  routers:{-->
<!--    handler(n, o) {-->
<!--      const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));-->
<!--      if(userInfo){-->
<!--        if(userInfo.user.superuser==1){-->
<!--          this.menudata=this.sidebarRouters-->
<!--        }-->
<!--        else{-->
<!--          this.menudata=this.GenerateRoutes(n);-->
<!--        }-->
<!--      }-->

<!--      // this.total = size;-->
<!--    },-->
<!--    deep: true-->
<!--  }-->
<!--},-->
<!--computed:{-->
<!--  ...mapState(['sidebarRouters','routers']),-->
<!--},-->

<!--  mounted() {-->
<!--    // this.menudata=this.sidebarRouters-->
<!--    const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));-->
<!--    if(userInfo){-->
<!--      if(userInfo.user.superuser==1){-->
<!--        this.menudata=this.sidebarRouters-->
<!--      }-->
<!--      else{-->
<!--        this.menudata=this.GenerateRoutes(this.routers);-->
<!--      }-->
<!--    }-->

<!--  },-->

<!--  methods:{-->
<!--    ...mapActions([-->
<!--          "set"-->
<!--    ]),-->
<!--    hasPermission(roles, route) {-->
<!--      return roles.some(role => role.name==route)-->
<!--    },-->
<!--    routersIndex(roles, route){-->
<!--      return roles.findIndex(role => role.name==route)-->
<!--    },-->
<!--    GenerateRoutes(data){-->
<!--      let roles=data;-->
<!--      let asyncRouterMap=this.sidebarRouters;-->
<!--      const accessedRouters =  asyncRouterMap.filter(v=>{-->

<!--        if(this.hasPermission(roles,v.code2)){-->
<!--          let index=this.routersIndex(roles,v.code2)-->
<!--          if(v.child&&v.child.length!==0){-->
<!--            v.child = v.child.filter(child => {-->
<!--              let index2=this.routersIndex(roles[index].children,child.code2)-->
<!--              if (this.hasPermission(roles[index].children, child.code2)) {-->
<!--                return child-->
<!--              }-->
<!--              return false;-->
<!--            });-->

<!--          }-->

<!--          return v;-->

<!--        }-->
<!--        return false-->

<!--        // roles.some(role=>{-->
<!--        // })-->
<!--      })-->
<!--      return accessedRouters;-->

<!--    },-->
<!--    handleSelect({item, key}) {-->
<!--      if (this.selectedKeys[0] !== key) {-->
<!--        const key2=key.split("-");-->
<!--        // ?id=${key2[1]}-->
<!--        this.selectedKeys = [`${key2[0]}-${key2[1]}`];-->
<!--        // const parent = item.parentMenu.eventKey;-->
<!--        // this.$router.push(`/${key2[0]}?id=${key2[1]}`);-->
<!--        this.$router.push({path:`/${key2[0]}`});-->
<!--        this.id=key2[1];-->
<!--      }-->
<!--    },-->
<!--    handleClick(e) {-->
<!--      const subjectType = e.key.substring(e.key.lastIndexOf("-")+1)-->
<!--      this.setSubjectType(subjectType)-->
<!--    },-->

<!--    // handleSelect({item, key}) {-->
<!--    //   if (this.selectedKeys[0] !== key) {-->
<!--    //     const key2=key.split("-");-->
<!--    //     this.selectedKeys = [`${key2[0]}-${key2[1]}`];-->
<!--    //     this.$router.push({path:`${key2[0]}`});-->
<!--    //   }-->
<!--    // },-->

<!--    // handleSelect({key}){-->
<!--    //   this.$router.push({path:key});-->
<!--    // }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->

<!--.ant-menu.ant-menu-dark .ant-menu-item-selected, .ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected{-->
<!--  /*background: #004082;*/-->
<!--  /*box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.45);*/-->
<!--  background: #364250;-->
<!--  color: #FFB600;-->
<!--}-->
<!--.ant-menu-dark .ant-menu-inline .ant-menu-sub{-->
<!--  background: #004082;-->
<!--}-->
<!--.ant-menu-dark{-->
<!--  height:100%;-->
<!--  text-align: left;-->
<!--  background: #4e596b;-->
<!--  /*background: linear-gradient(135deg, #0062A6 0%, #001B5A 100%);*/-->
<!--  scrollbar-width: none; /* firefox */-->
<!--  -ms-overflow-style: none; /* IE 10+ */-->
<!--  overflow-x: hidden;-->
<!--  overflow-y: auto;-->
<!--}-->

<!--.ant-menu-dark::-webkit-scrollbar {-->
<!--  display: none; /* Chrome Safari */-->
<!--}-->

<!--</style>-->



// WEBPACK FOOTER //
// src/components/UserMenu.vue